import React from 'react';
import SnapshotCardBase from './SnapshotCardBase';

const formatTry = (value) => `${Number(value || 0).toLocaleString('tr-TR', { maximumFractionDigits: 0 })} TL`;

export default function EconomySnapshotCard({ data, onOpenDrawer }) {
  return (
    <SnapshotCardBase
      title="Ekonomi"
      help={{
        description: 'Aylık ve yıllık ekonomik değer ile sepet kalitesini gösterir.',
        interpretation: 'AOV artarken dönüşüm düşerse erişim kalitesi kontrol edilmelidir.',
        metricExample: 'Aylık değer artıp dönüşüm sabitse hacim etkisi baskın olabilir.'
      }}
      primary={formatTry(data?.monthlyValueTry)}
      metrics={[
        { label: 'Yıllık', value: formatTry(data?.yearlyValueTry) },
        { label: 'AOV', value: formatTry(data?.aovTry) },
        { label: 'Dönüşüm', value: `${Number(data?.shoppingConversionRate || 0).toLocaleString('tr-TR')}%` }
      ]}
      onOpenDrawer={onOpenDrawer}
    />
  );
}
